import { render, staticRenderFns } from "./UserNetwork.vue?vue&type=template&id=10387ac8&scoped=true"
import script from "./UserNetwork.vue?vue&type=script&lang=js"
export * from "./UserNetwork.vue?vue&type=script&lang=js"
import style0 from "./UserNetwork.vue?vue&type=style&index=0&id=10387ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10387ac8",
  null
  
)

export default component.exports